import UserSupportContent from "../../../components/User/Support"

const UserSupport = () => {

    return (
        <>
            
            <UserSupportContent />

        </>
    )

}

export default UserSupport